module.exports = __webpack_public_path__ + "img/mv-logo.5dc117b2.svg";